<template>
  <div class="leaf-cohort py-1" :title="item.label" @click="$emit('click', $event)" @mousedown="$emit('mousedown', $event)">
    <b>{{ this.item.label }}</b>
    <div class="hvh-flex wrap">
      <div class="mr-3">CREATED: {{ formatDate(item.cohort.createdOn) }}</div>
      <div class="mr-3">PATIENTS: {{ (item.cohort.totalCount != null && customNumberFormat(item.cohort.totalCount)) || 'N/A' }}</div>
      <div class="mr-3">CREATOR: {{ item.cohort.createdBy || 'N/A' }}</div>
    </div>
  </div>
</template>

<script>
import { customNumberFormat, formatDate } from '../../../../libraries/common'
export default {
  noExport: true,
  props: ['item'],
  methods: {
    customNumberFormat,
    formatDate,
  }
}
</script>
